// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "code[data-v-1ba5f760]{background-color:#eee;padding:2px 5px;border-radius:2px;font-weight:700}", ""]);
// Exports
module.exports = exports;
